<template>
  <div class="edit-form-list-item">
    <div class="history-item">
      <div class="history-item-button">
        <div class="button">
          <el-button :disabled="!(index > 0 && length > 1)" icon="el-icon-arrow-up" circle
            @click.stop="handleCommand('moveUp')"></el-button>
        </div>
        <div class="button">
          <el-button :disabled="!(index + 1 != length && length > 1)" icon="el-icon-arrow-down" circle
            @click.stop="handleCommand('moveDown')"></el-button>
        </div>
      </div>
      <div class="history-item-content">
        <el-form class="history-form" ref="historyItemForm" :model="item" :rules="rules" @submit.native.prevent>

          <!--職種-->
          <div class="edit-form-item">
            <p class="item-name">希望業界</p>
            <label class="selectbox-3">
              <select v-model="item.hopeJobcategory" placeholder="選択してください">
                <option v-for="item in hopeJobcategoryOptions" :key="item" :value="item">{{ item }}</option>
              </select>
            </label>
          </div>

          <!--通年数-->
          <div class="edit-form-item">
            <div class="item-name"><label>通年数</label></div>
            <div class="form-date">
              <el-form-item>
                <el-input class="input-xxs" placeholder="5" title="年" v-model="item.totalYear" type="number"
                  :min="0" :max="100" ref="year">
                </el-input>
                <span>年</span>
              </el-form-item>
              <el-form-item>
                <el-input class="input-xxs input-2-digit" placeholder="11" title="月" v-model="item.totalMonth"
                  type="number" min="1" max="12" ref="month">
                </el-input>
                <span>ヶ月</span>
              </el-form-item>
            </div>
          </div>

          <!-- 詳細格納時にプロジェクト名だけ表示 -->
          <div class="projects" :class="{ 'project__invisible': isActive() == true }">
            <ul v-for="(item, index) in item.projects" :key="index">
              <li v-if="item.projectTitle == ''">会社等が未入力です</li>
              <li v-else>{{ item.projectTitle }}</li>
            </ul>
          </div>

          <div class="errors" v-if="errors">
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="enter text-right">
            <!-- <el-button icon="el-icon-plus" -->
            <!-- @click.stop="$eventHub.$emit('add-history-item-detail')">add</el-button> -->
          </div>
        </el-form>
      </div>
    </div>

    <!-- :class="{ 'detail__visible': this.activeHistoryItem != this.item.uuid}" -->
    <div class="projects" :class="{ 'project__invisible': isActive() == false }">
      <transition-group tag="div" name="list">
        <div class="project-item" @click.native="activateItem(item2)" v-for="(item2, index2) in item.projects"
          :index2="index2" :key="item2.uuid">
          <!-- <div class="history-item-button showButton"> -->
          <div class="showButton text-right project-item-button">
            <div class="button">
              <el-button :disabled="!(index2 > 0 && item.projects.length > 1)" icon="el-icon-arrow-up" circle
                @click.stop="moveUpDetail(index2)"></el-button>
            </div>
            <div class="button">
              <el-button :disabled="!(index2 + 1 != item.projects.length && item.projects.length > 1)"
                icon="el-icon-arrow-down" circle @click.stop="moveDownDetail(index2)"></el-button>
            </div>
          </div>
          <div class="project-item-content">
            <el-form class="history-form edit-form-item">
              <div class="item-name"><label for="projectTitle">会社名</label></div>
              <el-form-item prop="projectTitle">
                <el-input class="input-lg" type="textbox" id="projectTitle" :autosize="{ minRows: 1, maxRows: 4 }"
                  placeholder="会社名" v-model="item2.projectTitle" ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <el-form-item prop="businessArea">
                <div class="item-name"><label for="businessArea">事業内容</label></div>
                <el-input class="" type="textarea" id="businessArea" :autosize="{ minRows: 3, maxRows: 4 }"
                  placeholder="事業内容" v-model="item2.businessArea" ref="desc"></el-input>
              </el-form-item>

              <el-form-item prop="capitalStock" class="edit-form-item">
                <div class="item-name"><label for="capitalStock">資本金</label></div>
                <el-input class="input-sm" type="textbox" id="capitalStock" placeholder="資本金"
                  v-model="item2.capitalStock" ref="desc">
                </el-input>
                <span class="unit">万円</span>
              </el-form-item>

              <el-form-item prop="numberOfEmployees" class="edit-form-item">
                <div class="item-name"><label for="numberOfEmployees">従業員数</label></div>
                <el-input class="input-sm" type="textbox" id="numberOfEmployees" placeholder="従業員数"
                  v-model="item2.numberOfEmployees" ref="desc">
                </el-input>
                <span class="unit">名</span>
              </el-form-item>

              <div class="item-name"><label for="">期間</label></div>
              <div class="form-date">
                <el-form-item prop="startYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item2.startYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year">
                  </el-input>
                  <span>年</span>
                </el-form-item>
                <el-form-item prop="startMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item2.startMonth"
                    type="number" min="1" max="12" ref="month">
                  </el-input>
                  <span>月から</span>
                </el-form-item>
              </div>
              <div class="form-date">
                <el-form-item prop="endYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item2.endYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year">
                  </el-input>
                  <span>年</span>
                </el-form-item>
                <el-form-item prop="endMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item2.endMonth"
                    type="number" min="1" max="12" ref="month">
                  </el-input>
                  <span>月まで</span>
                </el-form-item>
              </div>
              <el-form-item prop="contentsOfProject">
                <div class="item-name"><label for="contentsOfProject">プロジェクトや業務内容の説明</label></div>
                <el-input class="input-lg" type="textarea" id="contentsOfProject" :autosize="{ minRows: 6, maxRows: 8 }"
                  placeholder="業務内容やプロジェクトの説明" v-model="item2.contentsOfProject" ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <!-- <el-form-item prop="position">
            <div class="item-name"><label for="position">役職</label></div>
            <el-input class="input-md"
                      type="textbox"
                      id="position"
                      placeholder="役職"
                      v-model="item2.position"
                      ref="desc">
            </el-input>
            <span></span>
          </el-form-item> -->
              <div class="enter">
                <el-button icon="el-icon-delete" type="text" size="small"
                  @click.stop="deleteDetail(index2)">この会社・実績を削除</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </transition-group>
      <div class="add-project-item enter">
        <el-button icon="el-icon-plus" @click.stop="handleCommand('addProject')">会社・実績を追加</el-button>
      </div>
      <div class="add-project-item enter">
        <el-button icon="el-icon-delete" @click.stop="handleCommand('delete')">削除</el-button>
        <el-button icon="el-icon-check" @click.stop="$eventHub.$emit('deactivate-history-item')">OK</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    },
    activeHistoryItem: {
      type: String
    }
  },
  data: function () {
    const app = this
    const validateYear = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 6) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateMonth = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 4) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      rules: {
        year: [
          {
            validator: validateYear,
            message: '年が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        month: [
          {
            validator: validateMonth,
            message: '月が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        description: [
          {
            validator: validateDescription,
            message: '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
            trigger: ['change', 'blur']
          }
        ]
      },
      hopeJobcategoryOptions: ['営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業']
    }
  },
  computed: {
    computedMinYear: function () {
      if (this.minYear) {
        return Number(this.minYear)
      }
      return 1980
    },
    computedMaxYear: function () {
      if (this.maxYear) {
        return Number(this.maxYear)
      }
      return new Date().getFullYear()
    }
  },
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-history-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-history-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-history-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-history-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'down'
        })
      } else if (command === 'addProject') {
        this.$emit('add-project-history-item', this.index, this.item)
      }
    },
    isActive: function () {
      if (this.activeHistoryItem === this.item.uuid) {
        return true
      } else {
        return false
      }
    },
    activateItem: function (id) {
      console.log(id)
    },
    deleteDetail: function (index2) {
      this.$emit('delete-history-item-detail', this.index, index2)
    },
    moveUpDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'up'
      }
      , this.index)
    },
    moveDownDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'down'
      }
      , this.index)
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs.desc.resizeTextarea === 'function') {
          if (app.$refs.desc.$el.offsetHeight) {
            app.$refs.desc.resizeTextarea()
          }
        }
      })
    },
    changeCheckbox: function () {
      if (this.item.isContinuing) {
        this.item.endYear = ''
        this.item.endMonth = ''
      }
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs.historyItemForm.validate().then().catch(function (e) {
        // console.error(e)
      })
    })
  },
  mounted: function () {
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
<style lang="scss" scoped>
$white: #fff;
$basecolor: #f8f8f8;
$light-gray: #dcdfe6;
$errorcolor: #f56c6c;

/* .projects { */
/* background-color:rgba(246,247,249,0.8); */
/* } */
.project__invisible {
  display: none;
}

.project__invisible2 {
  display: none;
}

.edit-form-list-item {
  &.active {
    .project-item {
      border-top: dashed 1px $light-gray;
      padding: 1rem 0;

      .enter {
        margin-top: .5rem;
      }
    }
  }
}

.history-item {
  display: flex;
  flex-direction: row-reverse;
}

.history-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

/* 詳細を隠す時に上下ボタンが高さを確保してしまうので修正 */
/* buttonにdisplay: flex; 追加 */
.history-item-button {
  .button {
    display: flex;

    button {
      &.is-disabled {}
    }
  }
}

.projects {
  margin-top: .5rem;

  >ul {
    list-style: none;
    // list-style-position: inside;
    font-size: .75rem;

    li {
      &::before {
        content: "";
        display: inline-block;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OTYgNDk2Ij48Zz48cGF0aCBkPSJNMjQ4LDBDMTExLDAsMCwxMTEsMCwyNDhTMTExLDQ5NiwyNDgsNDk2LDQ5NiwzODUsNDk2LDI0OCwzODUsMCwyNDgsMFpNNDAzLjMxLDE5NS4zMWwtMTg0LDE4NGgwYTE2LDE2LDAsMCwxLTIyLjYyLDBsLTEwNC0xMDRhMTYsMTYsMCwwLDEsMC0yMi42MmwyMi42Mi0yMi42M2ExNiwxNiwwLDAsMSwyMi42MywwTDIwOCwzMDAuMTIsMzU4LjA2LDE1MC4wNmExNiwxNiwwLDAsMSwyMi42MywwbDIyLjYyLDIyLjYzQTE2LDE2LDAsMCwxLDQwMy4zMSwxOTUuMzFaIi8+PC9nPjwvc3ZnPg==");
        margin-right: .25rem;
        width: .75rem;
        height: .75rem;
      }
    }
  }

  /* background-color: $basecolor; */
}

.project-item {
  display: flex;
  flex-direction: row-reverse;
  /* background: #f2f2f2; */
}

.project-item-button {
  display: flex;
  flex-direction: column;
  width: 3.5rem;

  // border-bottom: solid 1px darken($basecolor, 5);
  .button {
    flex: 1;

    button {
      height: 100%;
      border-radius: 0;
      border: none;

      &.is-disabled {
        color: darken($basecolor, 5);
      }
    }
  }
}

.project-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

.add-project-item {
  border-top: dashed 1px $light-gray;
  padding: 1rem;
  text-align: right;
}

.showButton {}

.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter-to {}

.list-enter-active,
.list-leave-active {}

.list-enter,
.list-leave {
  /* opacity: 0; */
  /* transform: translateX(50px) scaleY(0.5); */
}

.selectbox-3 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
}

.selectbox-3 select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  max-width: 100%;
  height: 2.8em;
  padding: .4em calc(.8em + 30px) .4em .8em;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background-color: #fff;
  color: #606266;
  font-size: 1em;
  cursor: pointer;
}

.selectbox-3::after {
  position: absolute;
  right: 15px;
  width: 10px;
  height: 7px;
  background-color: #808286;
  -webkit-clip-path: polygon(0 0, 100% 0, 50% 100%);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  content: "";
  pointer-events: none;
}
</style>
